import React from 'react';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';
import { injectIntl, IntlProvider } from 'react-intl';
import messagesPerLocale from '../locale/messages.json';

/* TODO: replace this surrogate implementation of ‘createIntl’ with the real function from FormatJS (requires upgrade of the package to version >= 3)
  See: https://formatjs.io/docs/intl/#createintl */
function createIntl({ locale, messages }) {
  let createdIntl;
  const SetCreatedIntl = injectIntl(({ intl: injectedIntl }) => {
    createdIntl = injectedIntl;
    return null;
  });
  ReactDOMServer.renderToString(
    <IntlProvider locale={locale} messages={messages}>
      <SetCreatedIntl />
    </IntlProvider>
  );
  return createdIntl;
}

function ensureGlobalIntlSet(locale) {
  if (window.intl === undefined) {
    window.intl = createIntl({ locale, messages: messagesPerLocale[locale] });
  }
}

/* TODO: replace this placeholder implementation of ‘RawIntlProvider’ with the real implementation from FormatJS (requires upgrade of the package to version >= 3)
  See: https://formatjs.io/docs/react-intl/components/#rawintlprovider
  Note that this placeholder implementation does not actually ‘provide’ the intl object as currently only the ‘imperative API’ of FormatJS is used ( https://formatjs.io/docs/react-intl/api ),
  none of the components that depend on ‘RawIntlProvider’ are used at the moment ( https://formatjs.io/docs/react-intl/components ) */
const RawIntlProvider = ({ children }) => <>{React.Children.only(children)}</>;
RawIntlProvider.propTypes = {
  value: PropTypes.shape({}).isRequired,
  children: PropTypes.element.isRequired
};

const RawIntlProviderGlobalIntl = ({ children }) => (
  <RawIntlProvider value={intl}>{React.Children.only(children)}</RawIntlProvider>
);
RawIntlProviderGlobalIntl.propTypes = {
  children: PropTypes.element.isRequired
};

/* TODO:
  - move the call of ‘ensureGlobalIntlSet’ to a script in ‘<head/>’ (through NPAbstractFrameComponent)
  - inline ‘IntlProviderDefaultMessages’
*/
export default class IntlProviderDefaultMessages extends React.Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.state = {};
    ensureGlobalIntlSet(props.locale);
  }

  /* Although highly unlikely that this happens in production,
     the component needs to be rerendered and the global intl updated when the locale changes.
     For now, used in testing (Storybook) */
  static getDerivedStateFromProps(props) {
    if (window.intl && window.intl.locale !== props.locale) {
      window.intl = undefined;
      ensureGlobalIntlSet(props.locale);
      return {};
    }
    return null;
  }

  render() {
    return <RawIntlProviderGlobalIntl>{this.props.children}</RawIntlProviderGlobalIntl>;
  }
}
